import axios from 'axios'
import { API_URL } from '../../../../modules/auth/core/_requests'
import { StoreInventory } from '../DeShippingTableWrapper'


export async function checkAvailability(variantId: string, quantity: number): Promise<StoreInventory[]> {
  try {
    const response = await axios.get(`${API_URL}/api/shopify-shipping/dashboard/availability`, {
      params: {
        productVariantId: variantId,
        quantity: quantity
      }
    })
    
    if (response.data && response.data.success) {
      return response.data.data
    } else {
      console.log(response.data)
      throw new Error(response.data?.error || 'Failed to retrieve inventory data')
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        throw new Error(error.response.data?.error || 'Failed to check availability')
      } else {
        throw new Error('Network error when checking availability')
      }
    }
    throw error
  }
}

export const getBulkAssignmentOptions = async (orderId: string, lineItemIds: string[]) => {
  const response = await fetch(`${API_URL}/api/shopify-shipping/dashboard/line-items-bulk-assignments/analyze`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      order_id: orderId,
      line_item_ids: lineItemIds
    })
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};
